<div class="column-flex">
    <div class="form-label">
        <ng-container *ngIf="!isEditing">
            {{ 'communication-protocols.dialog.title.create' | translate }}
        </ng-container>
        <ng-container *ngIf="isEditing">
            {{ 'communication-protocols.dialog.title.edit' | translate }}
        </ng-container>
    </div>

    <div class="main-container">
        <form class="input-form">
            <div class="graph-name-label">
                {{ 'communication-protocols.dialog.title.label' | translate }}
            </div>
            <app-channel-text-input
                label="communication-protocols.dialog.title.legend"
                [value]="title"
                [inputError]="validationErrors?.title"
                [maxLength]="48"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [noLabel]="true"></app-channel-text-input>
        </form>

        <form class="input-form">
            <div class="graph-name-label">
                {{ 'communication-protocols.dialog.type.label' | translate }}
            </div>
            <app-simple-dropdown
                style="height: 56px"
                [options]="TYPE_OPTIONS"
                [selectedOption]="selectedType"
                (onOptionSelected)="handleTypeChanged($event)">
            </app-simple-dropdown>
        </form>

        <form class="input-form">
            <div class="graph-name-label">
                {{ 'communication-protocols.dialog.board-type.label' | translate }}
            </div>
            <app-simple-dropdown
                style="height: 56px"
                [options]="BOARD_TYPE_OPTIONS"
                [selectedOption]="selectedBoardType"
                (onOptionSelected)="handleBoardTypeChanged($event)">
            </app-simple-dropdown>
        </form>
    </div>

    <div class="buttons-container">
        <div class="cancel button" (click)="cancel()">
            {{ 'dlg.cancel' | translate }}
        </div>
        <div
            *ngIf="!isEditing"
            class="create button"
            (click)="create()"
            [ngClass]="{ button_disabled: isCreateDisabled }">
            {{ 'dlg.create' | translate }}
        </div>
        <div *ngIf="isEditing" class="create button" (click)="create()" [ngClass]="{ button_disabled: isEditDisabled }">
            {{ 'dlg.edit' | translate }}
        </div>
    </div>
</div>
